import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../../../../../state'
import { configuration } from '../../../component-store'

@ngCore.Component({
  imports: [ds.input.text.Component],
  selector: 'atn-page-configuration-general-tab',
  standalone: true,
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.mosaic.dev.pages.Collection} */
  public readonly pagesEc = ngCore.inject(state.mosaic.dev.pages.Collection)

  /** @see {@link configuration.Store} */
  public readonly store = ngCore.inject(configuration.Store)

  /**
   * Updates a specific property of the currently edited page.
   */
  public updatePageConfiguration<
    K extends keyof (
      | ents.core.mosaic.Page.Input
      | ents.core.mosaic.Page.Updates
    ),
  >(
    prop: K,
    value: ents.core.mosaic.Page.Input[K] | ents.core.mosaic.Page.Updates[K],
  ): void {
    this.store.updateEditingPageConfiguration({ [prop]: value })
  }
}
